import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

type Props = {
  inicilizarTimer: number;
  clickDelete: () => void;
};

export const Timer = ({ inicilizarTimer, clickDelete }: Props): JSX.Element => {
  const [timerCard, setTimerCard] = useState<number>(inicilizarTimer);
  const navigate = useNavigate();

  useEffect(() => {
    const intervalID = setInterval(() => {
      setTimerCard((prev) => prev - 1000);
    }, 1000);
    return () => {
      clearInterval(intervalID);
    };
  }, [inicilizarTimer]);

  useEffect(() => {
    if (timerCard <= 0) {
      clickDelete();
      navigate("/");
    }
  }, [timerCard, clickDelete, navigate]);

  const functionTimer = (timers: number): string => {
    // Convertir milisegundos a segundos
    const totalSeconds = Math.floor(timers / 1000);
    // Calcular minutos y segundos restantes
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    // Retornar el tiempo formateado como mm:ss
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  return (
    <div className="p-2 text-center mb-3">
      {timerCard !== 0 && (
        <h4 className="develop___text">Tu sesión de compra finalizará en </h4>
      )}
      <h3 className="develop___text">
        {timerCard ? functionTimer(timerCard) : "00:00"}
      </h3>
    </div>
  );
};
